<script>
  import { _ } from 'svelte-i18n'
  import { onDestroy } from 'svelte'
  import { tweened } from "svelte/motion"
  import { sineOut } from "svelte/easing"
  import { handleUpsell } from '../modules/helpers'
  import { previews_scrolled_down, previews_font_size, user_valid, demos, previews_nav_filters, preview_mode } from '../stores'
  import PreviewsStepperButton from './PreviewsStepperButton.svelte';

  let demoing = false
	$: if ($demos) demoing = demos.valid('autoscroll')

  let scrolling = false
  let paused = true
  let frame
  let pause_timeout
  let last_mouse_x
  let last_mouse_y
  let user_speed_adjustment = 0;
  const speed = tweened(0, { duration: 600, easing: sineOut })
  
  // max speed based on font size value
  $: max_speed = () => {
    let val
    if ($preview_mode === "paragraphs") {
      // adjusted negative values
      val = 5 - Math.abs(Number($previews_font_size))
    } else {
      // adjusted for 0 value
      val = Math.max(Number($previews_font_size), 0.5)
    }
    // returned with user adjustment adjusted to min 0.5
    return Math.max(val + user_speed_adjustment, 0.5)
  }

  const loop = () => { 
    if (scrolling) window.scrollTo(0, window.scrollY + Math.round($speed))
    frame = requestAnimationFrame(loop)
  }
  export const start = () => { scrolling = true; paused = false; loop(); speed.set(max_speed()); console.log('Autoscroll - started at ' + max_speed() + 'px/frame') }
  const stop = () => { if(!scrolling) return; scrolling = false; paused = true; speed.set(0); cancelAnimationFrame(frame); clearTimeout(pause_timeout); console.log('Autoscroll - stopped') }
  const pause = () => { paused = true; speed.set(0); console.log('Autoscroll - paused') }
  const resume = () => { paused = false; speed.set(max_speed()); console.log('Autoscroll - resumed') }

  onDestroy(() => cancelAnimationFrame(frame))
  $: !$previews_scrolled_down && stop()
  $: $previews_nav_filters.selected && stop()

  export function handleMouseMove(event) {
    // treshold is 0 if mouse is close to bottom of screen
    let treshold = (event.clientY > window.innerHeight - 80) ? 0 : 40
    if(!scrolling || paused) {
      last_mouse_x = event.clientX
      last_mouse_y = event.clientY
      return
    }
    if(
      event.clientX > last_mouse_x + treshold 
      || event.clientX < last_mouse_x - treshold 
      || event.clientY + treshold < last_mouse_y 
      || event.clientY - treshold > last_mouse_y) {
      clearTimeout(pause_timeout)
      pause()
      pause_timeout = setTimeout(resume, 2000)
    }
	}

  export function handleMouseWheel() {
    if(!scrolling || paused) return
		stop()
	}

  const toggle = () => scrolling ? stop() : start()
  const increaseSpeed = () => { 
    user_speed_adjustment += 1
    resume()
  }
  const decreaseSpeed = () => { 
    user_speed_adjustment -= 1
    resume()
  }

</script>

<div class="autoScrollController" 
  on:click={() => handleUpsell('autoscroll')}
  class:pro_only={!$user_valid}
  class:in_view={$previews_scrolled_down && paused && !$previews_nav_filters.selected}
  class:demoing>
  
  <div class="buttons">
    <PreviewsStepperButton on_fill on:click={toggle}>
      {scrolling ? $_('buttons.stop') : $_('buttons.startAutoscroll') }
    </PreviewsStepperButton>

    {#if scrolling}
    
      <span> / </span>
      <PreviewsStepperButton 
        on_fill 
        active={user_speed_adjustment < 0} 
        disabled={max_speed() <= 0.5}
        on:click={decreaseSpeed}>
        {$_('buttons.slower')}
      </PreviewsStepperButton>
      
      <span> / </span>
      <PreviewsStepperButton 
        on_fill 
        active={user_speed_adjustment > 0}
        on:click={increaseSpeed}>
        {$_('buttons.faster')}
      </PreviewsStepperButton>
    {/if}
  </div>
</div>

<style>
  div {
    position: fixed;
    z-index: 3;
    bottom: -2rem;
    left: 50%;
    transform: translateX(-50%);
    transition: bottom var(--transition-props);
    transition-delay: 1000ms;
  }
  .buttons {
    display: flex;
    padding: 0.8rem 1.5rem;
    gap: 0.8rem;
    font-family: var(--PensumSans);
    font-size: 1.6rem;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    background-color: var(--c-button-bg);
  }
  div.in_view {
    bottom: 2rem;
    transition-delay: 0ms;
  }
  span {
    color: var(--c-text-faded-big);
		user-select: none;
  }
</style>